import Vue from 'vue';
import Vuetify from 'vuetify';
import 'vuetify/dist/vuetify.min.css';
import en from 'vuetify/lib/locale/en';
import fa from 'vuetify/lib/locale/fa';
import mdi from '@mdi/font/css/materialdesignicons.css';

Vue.use(Vuetify);

export default new Vuetify({
  lang: {
    locales: { fa, en, mdi },
    current: 'fa',
  },
  rtl: true,
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      default: 'light',
      light: {
        primary: '#3058a4',
        secondary: '#7e7e7e',
        accent: '#82B1FF',
        error: '#ff5d5d',
        info: '#4a9dc1',
        success: '#72b34d',
        warning: '#eeb32b'
      },
      dark: {
        primary: '#3058a4',
        secondary: '#7e7e7e',
        accent: '#82B1FF',
        error: '#ff5d5d',
        info: '#4a9dc1',
        success: '#72b34d',
        warning: '#eeb32b'
      },
    },
    icons: {
      iconfont: 'fa' || 'mdi' // 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
  },
});
